import "core-js/modules/es6.regexp.split";
import _values from "lodash/values";
import _isPlainObject from "lodash/isPlainObject";
export default {
  currentImage: state => state.currentImage,
  productInspiration: state => state.productInspiration,
  productCross: state => state.productCross,
  productComplementary: state => state.productComplementary,
  variants: state => state.variants,
  product: state => state.product,
  tc_vars: state => state.productNav.tc_vars.params,
  tracking: state => state.productNav.product.click_tracking,
  salesPromotion: state => state.productNav.sales_promotion,
  estimatedDelivery: state => state.productNav.product.estimated_delivery,
  delivery: state => {
    const delivery = {
      home: null,
      store: null
    };

    if (state.productNav.product.estimated_delivery && state.productNav.product.estimated_delivery.translation && state.productNav.product.estimated_delivery.translation.classic) {
      [, delivery.home] = state.productNav.product.estimated_delivery.translation.classic.split(';');
    }

    if (state.productNav.product.estimated_delivery && state.productNav.product.estimated_delivery.lgm_eligible && state.productNav.product.estimated_delivery.translation && state.productNav.product.estimated_delivery.translation.lgm) {
      [, delivery.store] = state.productNav.product.estimated_delivery.translation.lgm.split(';');
    }

    return delivery;
  },
  categorySticker: state => _isPlainObject(state.productNav.product.segmentations.category_sticker) ? _values(state.productNav.product.segmentations.category_sticker) : state.productNav.product.segmentations.category_sticker,
  gamme: state => state.productNav.product.cross.gamme,
  olapic: state => state.productNav.product.olapic
};